import axios from "axios";

const refreshToken = async () => {
  try {
    const token = localStorage.getItem("refresh_token");
    
    if (!token) {
      console.error("No refresh token available");
      return null;
    }
    
    //console.log("Using refresh token:", token);
    
    const response = await axios.post(
      "https://backend.newbrindha.com/photostudio/private/admin/refresh",
      { refresh_token: token }
    );
    
    console.log("✅ Refresh token response received");
    
    const newAccessToken = response.data.access_token;
    
    if (newAccessToken) {
      localStorage.setItem("access_token", newAccessToken);
      
      if (response.data.refresh_token) {
        localStorage.setItem("refresh_token", response.data.refresh_token);
      }
      
      return newAccessToken;
    } else {
      //console.error("Invalid response format from refresh token endpoint:", response.data);
      return null;
    }
  } catch (error) {
    // console.error(
    //   "Error refreshing token:", 
    //   error.response?.data || error.message
    // );
    
    if (error.response) {
      //console.error("Response status:", error.response.status);
     // console.error("Response data:", error.response.data);
    } else if (error.request) {
     // console.error("No response received:", error.request);
    }
    
    return null;
  }
};

export default refreshToken;